import React, { useState, useEffect } from 'react';
import useApp from "../hook/useApp";

const PopUp = () => {

    const { getPropusk, isPropusk } = useApp();

    const [isOpen, setIsOpen] = useState(false);

    const openPopup = () => {
        document.querySelector('.c_help-popup__video-overlay').classList.add('c_video-open');
    }

    useEffect(() => {
        document.body.classList.add('c_no-scroll');

        setTimeout(() => {
            setIsOpen(true)
        }, 1000);
    }, []);

    const togglePopup = () => {
        setIsOpen(!isOpen);

        document.body.classList.remove('c_no-scroll');

        setTimeout(() => {
            const element = document.getElementById('c_twoSection');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 1000);

    }

    return (
        <>
            <div className={isOpen ? "c_popup__overlay c_active" : "c_popup__overlay"}>
                <img className="c_popup__overlay-img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/overlay.png" />
                <div className="c_popup">
                    <div className="c_popup__title">Летний фестиваль</div>
                    <div className="c_popup__title-two"> 3 августа — 6 сентября </div>
                    <div className="c_popup__body">
                        <div className="c_popup__images">
                            <img className="c_popup__bg" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/pop-up-bg.png" />
                        </div>
                        <div className="c_popup__content">
                            <img className="c_popup__img c_popup__img-hand" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/timur/1-1.png?ver=33efw" />
                            <img className="c_popup__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/timur/1.png?ver=33few" />
                            <div className="c_text">
                                <p className='c_popup__sub-title'>Привет, друзья!</p>
                                <p>В эти дни мы с вами отмечаем день рождения нашей любимой игры. А какой праздник без подарков и приятных сюрпризов? Их есть у нас! Выполняйте несложные задачки и забирайте ценное имущество, которое мы приготовили для вас. И не забывайте радоваться, улыбаться и дарить нам ответные эмоции! С днём рождения всех нас!</p>
                            </div>

                            <div className='c_btn__wrap c_btn__wrap--left'>
                                {isPropusk ? (
                                    <div className="c_btn" onClick={(e) => {
                                        togglePopup(false);
                                    }}>
                                        <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-color.png" />
                                        <div className="c_btn__text">
                                            ТАК ТОЧНО!
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="c_btn" onClick={
                                            (e) => {
                                                getPropusk();
                                                togglePopup(false);
                                            }
                                        }>
                                            <img className="c_btn__img" alt="" src="https://tanki-media-content.tanki.su/ptl/sumfest/img/all/btn-color.png" />
                                            <div className="c_btn__text">
                                                Начнем!
                                            </div>
                                        </div>
                                    </>

                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PopUp;